import { useSession } from "@/features/auth";

export function ProfilePage() {
  const { data: user } = useSession();
  if (!user) return null;
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-10 p-8">
      <header>
        <h1 className="text-2xl font-semibold">Profile</h1>
        <p className="mt-1 text-sm text-[var(--fg-muted)]">
          Signed in as <span className="font-medium text-[var(--fg)]">{user.username}</span> ·{" "}
          {user.role}
        </p>
      </header>
      <section className="rounded-lg border border-[var(--border)] p-5 text-sm">
        <h2 className="text-sm font-semibold">Agent access (pi)</h2>
        <p className="mt-2 text-[var(--fg-muted)]">
          rtfm has no API keys. In pi, install <code>@pi/rtfm</code> and run <code>/login</code> →{" "}
          <span className="font-medium text-[var(--fg)]">RTFM</span>: sign in with the same
          authentik account; pi keeps the token fresh.
        </p>
      </section>
    </div>
  );
}
